import { Link, Stack, Typography, type TypographyProps } from "@mui/material";
import type { ReactNode } from "react";
import { Link as RouterLink } from "react-router";
import UserAvatar from "./UserAvatar";

interface Props {
  userName: string;
  userNameHref?: string;
  nameSuffix?: ReactNode;
  email?: string;
  avatarSize?: "small" | "medium" | "large";
  userNameVariant?: TypographyProps["variant"];
}

const UserWithAvatar = ({ userName, userNameHref, nameSuffix, email, avatarSize, userNameVariant }: Props) => {
  return (
    <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
      <UserAvatar size={avatarSize ?? "medium"} userName={userName} />
      <Stack spacing={0.25}>
        {userNameHref ? (
          <Link
            component={RouterLink}
            to={userNameHref}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            variant={userNameVariant ?? "body1"}
          >
            {userName}
            {nameSuffix}
          </Link>
        ) : (
          <Typography variant={userNameVariant ?? "body1"}>
            {userName}
            {nameSuffix}
          </Typography>
        )}
        {email && (
          <Typography variant="caption" color="textSecondary">
            {email}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default UserWithAvatar;
